// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"one-image_wrapper__vmX_b","title":"one-image_title__W3S2i","text":"one-image_text__bODkM"};